export default "__VITE_ASSET__1b200261__"